import { Component, OnInit, OnDestroy } from '@angular/core';
import { Auth } from 'src/app/models/auth';
import { UnidadeCadastro } from 'src/app/models/unidade-cadastro';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Unidade } from 'src/app/models/unidade';
import { Subscription } from 'rxjs';
import { UnidadeService } from 'src/app/services/unidade.service';
import { AuthenticationService } from 'src/app/services/authentication.service';

import { Router, ActivatedRoute } from '@angular/router';
import { GenericValidator } from '../../../../../shared/validators/generic-validator.validator';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { StatusCadastro } from 'src/app/shared/enums/status-cadastro.enum';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';

@Component({
    selector: 'app-unidade-edit',
    templateUrl: './unidade-edit.component.html',
    styleUrls: ['./unidade-edit.component.css']
})
export class UnidadeEditComponent implements OnInit, OnDestroy {

    private currentUser: Auth;
    public unidadeCadastro: UnidadeCadastro;

    public unidadeFormGroup: FormGroup;
    public canEdit = false;

    private unidade: Unidade;
    private id: number;
    private routeSubscription: Subscription;

    public StatusCadastro = StatusCadastro;

    constructor(
        private formBuilder: FormBuilder,
        private unidadeService: UnidadeService,
        private authenticationService: AuthenticationService,
        private alertService: NewAlertService,
        private router: Router, private route: ActivatedRoute) {
    }

    ngOnInit() {
        this.routeSubscription = this.route.paramMap.subscribe(params => {
            this.id = +params.get('id');
        });

        this.currentUser = this.authenticationService.currentUserValue;

        // usar para criar / editar
        this.createForm(new UnidadeCadastro('', '', null));
        // validar se foi para esse componente com o id do centro de custo (sim = editar) (não = cadastrar)
        this.unidadeService.getById(this.id, this.currentUser.token.assignorGuid).subscribe(
            response => {
                this.unidade = response.result;
                this.createForm(this.unidade);
                this.canEdit = true;
            },
            error => {
                this.alertService.error('Não foi possível encontrar o centro de custo.');
                this.router.navigate(['list'], { relativeTo: this.route.parent });
            }
        );

    }

    ngOnDestroy() {
        this.routeSubscription.unsubscribe();
    }

    public get form() {
        return this.unidadeFormGroup.controls;
    }

    createForm(unidadeCadastro: UnidadeCadastro) {
        this.unidadeFormGroup = this.formBuilder.group({
            nome: new FormControl(unidadeCadastro.nome, [
                Validators.required,
                Validators.maxLength(100)
            ]),
            codigo: new FormControl(unidadeCadastro.codigo, [
                Validators.required,
                Validators.maxLength(15)
            ]),
            status: new FormControl(unidadeCadastro.status, [

            ]),
            limite: new FormControl(unidadeCadastro.limite)
        });
    }

    onSubmit(unidadeCadastro: UnidadeCadastro) {
        if (this.unidadeFormGroup.valid) {
            this.unidadeService
                .update(this.id, unidadeCadastro, this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId).subscribe(
                    response => {
                        if (response.status === ApiError.Sucesso) {
                            this.alertService.success(response.message, true);
                            this.router.navigate(['list'], { relativeTo: this.route.parent });
                        } else {
                            this.alertService.error(response.message);
                        }
                    }
                );
        } else {
            GenericValidator.verifierValidatorsForm(this.unidadeFormGroup);
        }
    }

}
